<template>
  <v-dialog v-model="getModalCadastroEtiqueta" fullscreen>
    <v-card outlined :loading="$store.getters.getOverlay">
      <v-card-title>
        Cadastro de Etiqueta
      </v-card-title>
      <v-form @submit.prevent="salvar" class="px-3">
        <v-card-text>
          <v-layout row wrap class="">
            <v-flex xs12 md6>
              <v-text-field
                dense
                outlined
                v-model="getEtiqueta.nome"
                label="Nome"
                class="ml-1 mr-1"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-file-input
                label="Template"
                @change="selecionaTemplate"
                outlined
                dense
                class="mr-1 ml-1"
              ></v-file-input>
            </v-flex>
            <v-flex xs12 md6>
              <v-select
                :items="[
                  'DESCRIÇÃO PRODUTO',
                  'PREÇO DE VENDA PRODUTO',
                  'CÓDIGO PRODUTO',
                  'CÓDIGO BARRAS PRODUTO',
                ]"
                v-model="conteudo.nome"
                class="ml-1 mr-1"
                label="Conteúdo"
                outlined
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                name="name"
                label="Tamanho da fonte"
                v-model="conteudo.fonte_tamanho"
                class="ml-1 mr-1"
                outlined
                dense
                type="number"
                append-outer-icon="control_point"
                @click:append-outer="addConteudoEtiqueta"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text>
          <v-simple-table dense>
            <template v-slot:default> 
              <thead>
                <tr>
                  <th>CONTEÚDO</th>
                  <th>TAMANHO DA FONTE</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="c in conteudosEtiqueta" :key="c.nome">
                  <td>{{c.nome}}</td>
                  <td>{{c.fonte_tamanho}}</td>
                  <td>
                    <v-btn
                        x-small
                        color="error"
                        @click="removerConteudo(c)"
                        outlined
                      >
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="white--text"
            color="blue-grey"
            @click="setModalCadastroEtiqueta(false)"
            outlined
            >Voltar</v-btn
          >
          <v-btn
            v-if="
              getEtiqueta.id && $helper.verificaPermissao('cadastrar-etiqueta')
            "
            color="primary"
            @click="cadastrarEtiqueta"
            outlined
            >Novo</v-btn
          >
          <v-btn
            v-if="
              getEtiqueta.id && $helper.verificaPermissao('excluir-etiqueta')
            "
            color="error"
            @click.stop="setModalExcluirEtiqueta(true)"
            outlined
            >Excluir</v-btn
          >
          <v-btn color="default" v-if="getEtiqueta.template_path" @click="visualizarTemplate()" outlined>Visualizar Template</v-btn>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            @click="salvar"
            outlined
            :loading="$store.getters.getOverlay"
            v-if="
              $helper.verificaPermissao('cadastrar-etiqueta') ||
                $helper.verificaPermissao('atualizar-etiqueta')
            "
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>

    <ModalExcluirEtiqueta />
  </v-dialog>
</template>

<script>
import ModalExcluirEtiqueta from "@/pages/etiqueta/ModalExcluir";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    ModalExcluirEtiqueta,
  },
  data() {
    return {
      conteudosEtiqueta: [],
      conteudo: {
        nome: "",
        fonte_tamanho: "",
      },
    };
  },
  watch: {
    getModalCadastroEtiqueta: function(){
      if(this.getModalCadastroEtiqueta == true && this.getEtiqueta.id){
        this.conteudosEtiqueta = this.getEtiqueta.conteudo
      }else{
        this.conteudosEtiqueta = []
      }
    }
  },
  computed: {
    ...mapGetters(["getEtiqueta", "getModalCadastroEtiqueta"]),
  },
  methods: {
    ...mapActions([
      "setModalCadastroEtiqueta",
      "setModalExcluirEtiqueta",
      "cadastrarEtiqueta",
      "salvarEtiqueta",
      "atualizarEtiqueta",
    ]),
    salvar() {
      const form = new FormData();
      form.append("nome", this.getEtiqueta.nome);
      form.append("template", this.getEtiqueta.template);

      if (this.conteudosEtiqueta.length > 0) {
        this.conteudosEtiqueta.forEach(function (element) {
            form.append('conteudos[]', JSON.stringify(element));
        })
      }

      if (this.getEtiqueta.id) {
        form.append("_method", "PUT");
        form.append("id", this.getEtiqueta.id);
        this.atualizarEtiqueta(form);
      } else {
        this.salvarEtiqueta(form);
      }
    },
    removerConteudo(payload){
      let index = this.conteudosEtiqueta.map(x => x).indexOf(payload);
      this.conteudosEtiqueta.splice(index, 1)
    },
    addConteudoEtiqueta() {
      if(this.conteudo.nome == ""){
        this.$store.commit('snackbarError', 'Selecione o conteúdo.')
        return
      }

      if(this.conteudo.fonte_tamanho == ""){
        this.$store.commit('snackbarError', 'Informe o tamanho da fonte.')
        return
      }

      this.conteudosEtiqueta.push({...this.conteudo});
      this.conteudo.nome = ""
      this.conteudo.fonte_tamanho = ""
    },
    selecionaTemplate(e) {
      this.getEtiqueta.template = e;
    },
    visualizarTemplate(){
      window.open(this.getEtiqueta.template_url);
    }
  },
};
</script>
